import * as React from 'react';
export default function SvgAries() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.432 8.614A2.25 2.25 0 017 4.75c1.157 0 1.85 1.249 2.247 2.336C10.227 9.774 12 15.197 12 19.25M18.567 8.614A2.25 2.25 0 0017 4.75c-1.157 0-1.85 1.249-2.247 2.336C13.773 9.774 12 15.197 12 19.25",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}